import React from 'react';
import PropTypes from 'prop-types';
import { DataPairLayout } from '../DataPairLayout';
import { SubtitleSmall, ContentData } from '../Typography';

const DataPair = props => {
  const titleNode = (
    <SubtitleSmall>{props.title}</SubtitleSmall>
  );
  const childrenNode = (
    <ContentData>{props.text}</ContentData>
  );

  return <DataPairLayout title={titleNode}>{childrenNode}</DataPairLayout>;
};

DataPair.propTypes = {
  /** Title to be shown on the top */
  title: PropTypes.string.isRequired,
  /** Text to be shown on the content */
  text: PropTypes.string.isRequired
};

export { DataPair };
